import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Heading, Spinner, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ServiceTypeForm } from '@/components/forms/ServiceTypeForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function ServiceTypeEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!numericId || Number.isNaN(numericId)) {
      navigate('/service-catalog/service-types', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [numericId, navigate])

  const handleSuccess = () => {
    navigate('/service-catalog/service-types')
  }

  const handleCancel = () => {
    navigate('/service-catalog/service-types')
  }

  if (isValidating || !numericId) {
    return (
      <AdminLayout>
        <Box p={4} display="flex" alignItems="center" justifyContent="center" minH="200px">
          <Spinner size="lg" />
          <Text ml={3}>Loading...</Text>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex={1}>
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Edit Service Type</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Update service type details
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex={1} minH={0}>
              <ServiceTypeForm
                serviceTypeId={numericId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
